import { api } from "../../../api/config";
import { RecordingStatus } from "../terminal-payment/terminalPaymentApi";
import { SplitPayment } from "../split-payment/splitPayments";

export type MbwayRequestStatus = "pending" | "paid" | "refused" | "expired" | "declined" | "failed" | "replaced";

export type MbwayRequest = {
    id: number;
    status: MbwayRequestStatus;
    amount: number;
    failure_reason: string | null;
    phone_masked: string;
    request_confirmed: boolean;
    seconds_remaining: number;
    recording_status: RecordingStatus | null;
    split_payments: Array<SplitPayment>;
};

type ResponsibleRelatives = {
    relative_resposible_for_treatment: Array<{ relatives_id: { Nome: string | null; telemovel: string | null } | null }> | null;
};

export const isOpenMbwayRequest = (request: MbwayRequest | null) => {
    const isOpen = request?.status === "pending";
    return isOpen;
};

export const fetchLatestMbwayRequest = async (orderId: number) => {
    const response = await api.get("/payments/mbway/requests/latest", { params: { order_id: orderId } });
    const latestRequest = response.data.data as MbwayRequest | null;
    return latestRequest;
};

export const startMbwayRequest = async (orderId: number, phone: string, splitPayments: Array<SplitPayment>) => {
    const response = await api.post("/payments/mbway/requests", { order_id: orderId, phone, split_payments: splitPayments });
    const startedRequest = response.data.data as MbwayRequest;
    return startedRequest;
};

export const replaceMbwayRequest = async (requestId: number) => {
    const response = await api.post(`/payments/mbway/requests/${requestId}/replace`);
    const replacedRequest = response.data.data as MbwayRequest;
    return replacedRequest;
};

export const fetchResponsibleRelativePhone = async (treatmentId: number) => {
    const response = await api.get(`items/treatments/${treatmentId}`, {
        params: {
            fields: "relative_resposible_for_treatment.relatives_id.Nome,relative_resposible_for_treatment.relatives_id.telemovel",
        },
    });
    const treatment = response.data.data as ResponsibleRelatives;
    const responsibleRelativePhone = treatment.relative_resposible_for_treatment?.[0]?.relatives_id?.telemovel ?? null;
    return responsibleRelativePhone;
};
